import { FunctionComponent, memo, useEffect, useState } from "react";

import SectionHeader from "./sectionHeader";
import styles from "./SectionsAccordion.module.scss";
import CriteriumContainer from "../criterium/criteriumContainer";

import AccordionList from "@components/generic/accordion/accordionList";
import { ThemeCode } from "@lib/helper/themeUtils";
import { IBrandSource } from "@lib/store/models/brandsModels";
import { ISectionNode } from "@lib/store/models/nodesModels";
import { useReferential } from "context/referentialContext";

export interface ISectionsAccordionProps {
  themeCode: ThemeCode;
  brandSourcesByCriteriumId?: { [id: string]: IBrandSource[] };
}

const LOADER_CONFIGURATION = {
  nbOfItems: 3,
  className: styles["sections-accordion"],
  itemClassName: styles["sections-accordion__item"],
};

const SectionsAccordion: FunctionComponent<ISectionsAccordionProps> = ({ themeCode, brandSourcesByCriteriumId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [sections, setSections] = useState<ISectionNode[]>([]);

  const { getSections, depth, sectionDisplayOptions = {} } = useReferential();

  const { withBonusSection = true } = sectionDisplayOptions;

  useEffect(() => {
    setIsLoading(true);
    getSections(themeCode)
      .then(setSections)
      .finally(() => setIsLoading(false));
  }, [getSections, themeCode]);

  return (
    <AccordionList
      className={styles["sections-accordion"]}
      items={sections}
      isDisabled={({ hasCriterium }) => hasCriterium === false}
      filter={({ isBonus }) => (withBonusSection ? true : !isBonus)}
      renderHeader={({ score, name, isBonus }) => <SectionHeader score={score} name={name} isBonus={isBonus} />}
      itemClassName={styles["sections-accordion__item"]}
      loading={isLoading}
      loaderConfiguration={LOADER_CONFIGURATION}
      renderContent={({ id, name }) => (
        <CriteriumContainer sectionName={name} sectionId={id} brandSourcesByCriteriumId={brandSourcesByCriteriumId} />
      )}
      lazy
      withAutoClose
      itemTestId="section"
      unopenable={depth === "sections"}
    />
  );
};

export default memo(SectionsAccordion);
